<template>
  <div>
    <van-tabs v-model="activeTab" sticky @change="onTabChange">
      <van-tab name="current" title="本期排名">
        <div class="page" v-if="myRanking != null && myRanking!==undefined">
          <div >
            <div class="my">
              <div class="rank" style="display: flex">
                <div class="avatar-wrap" style="margin-left: 0">
                  <img :src="myRanking.clerkAvatarUrl" style="width: 60px;height: 60px;border-radius: 50%;">
                  <div :class="`grade_${myRanking.clerkGrade}`" class="grade-tag">
                    {{ $store.state.ClerkGradeMap[myRanking.clerkGrade] }}
                  </div>
                </div>
                <div class="data">
                  <div class="amount-wrap">
                    <span style="font-size: 16px;margin-left: 2px;">第</span>
                    <span style="font-size: 30px">{{ myRanking.ranking }}</span>
                    <span style=" font-size: 16px;margin-left: 2px;">名</span>
                  </div>
                  <div style=" color: #ffffff90;font-size: 16px;margin-top: 2px;">我的名次</div>
                </div>
              </div>
              <div class="info"
                   style="color: white;background: var(--primary-color); margin-top: 10px; display:flex;flex-direction: row;">
                <div style="display: flex;flex-direction: column;">
                  <div style="display: flex;" v-if="$store.state.shop.id !== 2362">
                    <span class="label" style="width: 80px">订单数：{{ myRanking.orderCount }}</span>
                    <span class="label" style="margin-left: 5px">订单金额：￥{{ formatPrice(myRanking.orderAmount) }}</span>
                  </div>
                  <span v-if="$hasFeature('custom_2362')" class="label">实际流水：￥{{ formatPrice(myRanking.actualIncome) }}</span>
                  <div style="display: flex;" v-if="$store.state.shop.id !== 2362">
                    <span class="label" style="width: 80px">续单数：{{ myRanking.continuedCount }}</span>
                    <span class="label" style="margin-left: 5px">续单金额：￥{{
                        formatPrice(myRanking.continuedAmount)
                      }}</span>
                  </div>
                  <div style="display: flex;" v-if="$store.state.shop.id !== 2362">
                    <span class="label" style="width: 200px">接单超时数：{{confirmTimeoutCount}}</span>
                  </div>
                  <div style="display: flex;" v-if="$store.state.shop.id !== 2362">
                    <span class="label" style="width: 200px">距离前一名金额：￥{{
                        formatPrice(myRanking.distancePreviousAmount)
                      }}</span>
                  </div>
                  <!--                  <div style="display: flex;">-->
                  <!--                    <span class="label" style="width: 80px">退单数：{{ myRanking.refundedCount }}</span>-->
                  <!--                    <span class="label" style="margin-left: 5px">退单金额：{{ myRanking.refundedAmount }}</span>-->
                  <!--                  </div>-->
                  <div style="display: flex;justify-content: space-around">
                    <span class="label">统计时间：{{ beginTime }} - {{ endTime }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <van-list
              v-model="loading"
              :finished="listFinished"
              finished-text="没有更多了"
              @load="loadData"
          v-if="this.visibleClerkRanking.indexOf('clerkRanking')!=-1">
            <div class="ranking-list">
              <div v-for="(item, index) in rankingList" :key="index" style="margin-top: 10px;padding: 10px 15px;
              background: #fff;border-radius: 10px;">
                <div class="rank" style="display: flex" v-if="!item.isHideRanking">
                  <div class="avatar-wrap" style="margin: 0 0">
                    <img :src="item.clerkAvatarUrl" style="width: 60px;height: 60px;border-radius: 50%;">
                  </div>
                  <div class="data"
                       style="margin-left: 20px;display: flex;justify-content: space-between;flex: 1;width: 100%">
                    <div style="flex: 1;">
                      <div style="font-size: 18px">
                        <span>{{ item.clerkName }}</span>
                        <i v-if="item.clerkSex===2" class="iconfont icon-sex-woman" style="color: palevioletred"/>
                        <i v-if="item.clerkSex===1" class="iconfont icon-sex-man" style="color: #04ade0"/>
                      </div>
                      <div style="margin-top: 5px">
                        <van-tag type="warning">{{ $store.state.ClerkGradeMap[item.clerkGrade] }}</van-tag>
                      </div>
                    </div>

                    <div class="amount-wrap" style="display: flex;align-items: center">
                      <!--<span style="font-size: 16px;margin-left: 2px;">第</span>-->
                      <span :data-ranking="item.ranking" class="ranking" style="font-size: 30px">{{
                          item.ranking
                        }}</span>
                      <!--<span style=" font-size: 16px;margin-left: 2px;">名</span>-->
                    </div>

                  </div>
                </div>
                <div class="rank" style="display: flex" v-else>
                  <div class="avatar-wrap" style="margin: 0 0">
                    <img src="/static/images/default/clerk-avatar.png" style="width: 60px;height: 60px;border-radius: 50%;border: 1px solid #d5d0d0;">
                  </div>
                  <div class="data"
                       style="margin-left: 20px;display: flex;justify-content: space-between;flex: 1;width: 100%">
                      <div style="font-size: 18px;display: flex;align-items: center">
                        <span>匿名店员</span>
                      </div>
                    <div class="amount-wrap" style="display: flex;align-items: center">
                      <!--<span style="font-size: 16px;margin-left: 2px;">第</span>-->
                      <span :data-ranking="item.ranking" class="ranking" style="font-size: 30px">{{
                          item.ranking
                        }}</span>
                      <!--<span style=" font-size: 16px;margin-left: 2px;">名</span>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>

      <van-tab name="history" title="往期排名">
        <van-list
            v-model="history.loading"
            :finished="history.listFinished"
            finished-text="没有更多了"
            @load="getHistoryRanking"
        >
          <van-cell-group class="history-wages-list">
            <van-cell v-for="(item, index) in history.list" :key="index" center size="large" value-class="amount">
              <!--                          {{item}}-->
              <span
                  slot="title">{{
                  formatDate(item.beginTime, 'YYYY-MM-DD')
                }} 至 {{ formatDate(item.endTime, 'YYYY-MM-DD') }}</span>
              <span class="text-lg text-red text-bold" style="width: 80px;">{{ item.ranking }}</span>
            </van-cell>
          </van-cell-group>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Dialog, List, Tab, Tabs, Toast} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import {getHistoryRankings, getRankingList} from "@/api/clerk/ranking";
import { Tag } from 'vant';
Vue.use(Tag);
Vue.use(Cell)
    .use(CellGroup)
    .use(Tab)
    .use(Tabs)
    .use(List)
    .use(Toast)
    .use(Dialog)

export default {
  name: 'ranking-list-new',
  data() {
    return {
      activeTab: 'current',
      current: null,
      history: {
        loading: false,
        listFinished: false,
        list: [],
        pageNo: 1,
        pageSize: 20
      },

      pageNo: 1,
      pageSize: 20,
      myRanking: null,
      confirmTimeoutCount: 0,
      beginTime: null,
      endTime: null,
      rankingList: [],
      visibleClerkRanking: [],
      loading: false,
      listFinished: false,
    }
  },
  methods: {
    onTabChange(name) {
      if (name == 'current') {
        this.loadData(true)
      } else if (name == 'history') {
        this.getHistoryRanking(true)
      }
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.rankingList = [];
      }
      this.loading = true
      getRankingList(
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code === 0) {
          if(data.list===null){
            return;
          }
          this.rankingList = this.rankingList.concat(data.list)
          this.visibleClerkRanking=data.visibleClerkRanking
          if(data.myRanking){
            this.myRanking = data.myRanking
            this.confirmTimeoutCount = data.confirmTimeoutCount;
            this.beginTime = data.beginTime
            this.endTime = data.endTime
          }

          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    },
    getHistoryRanking(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.history.pageNo = 1
      }
      // 清空数据
      if (this.history.pageNo == 1) {
        this.history.list = [];
      }
      this.history.loading =true;
      getHistoryRankings(this.history.pageNo,
          this.history.pageSize).then(res => {
        Toast.clear()
        this.history.loading = false
        const data = res.data;
        if (data.code === 0) {
          this.history.list = this.history.list.concat(data.list);
          if (data.hasNextPage) {
            this.history.listFinished = false
          } else {
            this.history.listFinished = true
          }
        } else {
          this.history.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.history.pageNo++
      })
    }
  },
  mounted() {
    this.loadData()
    // this.getCurrentWages()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>


<style lang="less" scoped>

.ranking {
  &[data-ranking="1"] {
    color: #fbbd08;
  }

  &[data-ranking="2"] {
    color: #e2781c;
  }

  &[data-ranking="3"] {
    color: #e82d2d;
  }
}

.page {
  padding: 10px;

  .my {
    padding: 10px 15px;
    color: white;
    background: var(--primary-color);
    display: flex;
    border-radius: 10px;
    flex-direction: column;

    .rank {
      .data {
        margin-left: 20px;

        .amount-wrap {
          .amount {
            font-size: 30px;
          }

          .text {
            font-size: 16px;
            margin-left: 2px;
          }
        }

        .label {
          color: #ffffff90;
          font-size: 16px;
          margin-top: 2px;
        }
      }
    }
  }

  .ranking-list {
    margin-top: 10px;

    .item {
      margin-top: 10px;
      padding: 10px 15px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;

      .position {
        color: #aaa;
        font-size: 28px;
        width: 50px;
        text-align: center;

        &[data-ranking="1"] {
          color: #fbbd08;
        }

        &[data-ranking="2"] {
          color: #e2781c;
        }

        &[data-ranking="3"] {
          color: #e82d2d;
        }
      }

      .avatar-wrap {
        margin: 0 10px;
      }

      .name {
        color: #333;
        font-size: 16px;
        margin-left: 10px;
      }

      /*&:nth-child(1) {*/
      /*    .position {*/
      /*        color: #fbbd08;*/
      /*    }*/
      /*}*/
      /*&:nth-child(2) {*/
      /*    .position {*/
      /*        color: #e2781c;*/
      /*    }*/
      /*}*/
      /*&:nth-child(3) {*/
      /*    .position {*/
      /*        color: #e82d2d;*/
      /*    }*/
      /*}*/
    }
  }

  .avatar-wrap {
    position: relative;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .grade-tag {
      font-size: 10px;
      color: #fff;
      padding: 2px 5px;
      border-radius: 8px;
      position: absolute;
      right: 0;
      bottom: 0;

      &.grade_1 {
        background: #373737;
      }

      &.grade_2 {
        background: #FFA43E;
      }

      &.grade_3 {
        background: #FF693E;
      }

      &.grade_4 {
        background: #ffb1d0;
      }

      &.grade_5 {
        background: #a1131a;
      }
    }
  }
}

.history-wages-list {
  .amount {
    flex: none;
  }
}

</style>
